
import React from 'react'

export default function ShopifyData() {
    return (
        <div className="hero-section e-comm cSection">
            <div className="cContainer">
                <div className="hero-wrapper">
                    <div className="left-content">
                        <h2>Shopify</h2>
                        <h3>Personalized Shopify Store</h3>
                        <p className='text-1'>Utilize Shopify features to your advantage</p>
                        <a href="/contact" className='cBtn btn'>Get started!</a>
                    </div>
                    <div className="right-content">
                        <img src={require('../asstes/Shopify Expert.jpg')} alt="Hero" />
                    </div>
                </div>
            </div>
        </div>
    )
}